import { TableSortingOrder } from "@/components/AppTable/ITable"
import { BlockNotification } from "@/modules/applications/blockNotifications/types/notificationTypes"
import { DataUrlSubPath } from "@/modules/provide/digital-twin-browser/types/shellTypes"

export enum EnumBnPageNames {
  BN_SEND = "send_notifications",
  BN_SENT = "sent_notification_history",
  BN_RECEIVED = "received_notification_history"
}

export enum NotificationType {
  PROVISIONS = "provisions",
  CONSUMPTIONS = "consumptions"
}

export enum HistorySource {
  SENT = "sent",
  RECEIVED = "received"
}

export interface Partner {
  name: string
  receivedCount: number
  sentCount: number
  total: number
}

export interface StatisticsState {
  totalAffectedParts: number
  topPartners: Partner[]
  sentNotifications: number
  receivedNotifications: number
  isLoading: boolean
}

export interface BlockNotificationsState {
  notifications: BlockNotification[]
  selectedNotification: BlockNotification | null
  page: number
  size: number
  total: number
  totalPages: number
  dataUrlSubPath: DataUrlSubPath | null
  isLoading: boolean
  sorting: {
    field: string
    type: TableSortingOrder
  }
}

export type BlockNotificationsFilterKey =
  | "conversationName"
  | "problemId"
  | "bpn"
  | "minCreatedAt"
  | "maxCreatedAt"
  | "createdBy"

export interface RecentNotificationsState {
  notifications: any[]
  isLoading: boolean
}

export interface GeneralInfo {
  name: string
  receiverBpn: string
  expectedResponseBy: string
}
